module.exports = __webpack_public_path__ + "img/57_8.b1c0f87c.png";